import axiosInstance from '../helpers/axiosInstance';

export const createInitialPackageApi = async (request) => {
    const response = await axiosInstance.post('staff/addPackage', request.formData);
    return response.data;
};

export const updatePackageApi = async (request) => {
    const response = await axiosInstance.put('staff/editPackage', request.formData);
    return response.data;
};

export const getPackageListApi = async (request) => {
    const response = await axiosInstance.post('staff/getPackagesList', request.formData);
    return response.data;
};

export const addPackageProductApi = async (request) => {
    const response = await axiosInstance.post('staff/package/addProduct', request.formData);
    return response.data;
};

export const editPackageProductApi = async (request) => {
    const response = await axiosInstance.put('admin/package/editProduct', request.formData);
    return response.data;
};

export const getProductListByPackageIdApi = async (request) => {
    const response = await axiosInstance.get(`staff/getPackageProducts?packageId=${request.id}`);
    return response.data;
};

export const getPackageProductsDropdownApi = async (request) => {
    const response = await axiosInstance.get(`staff/package/product-dropdown?searchKey=${request.searchKey}`);
    return response.data;
};

export const getProductsDropdownApi = async (request) => {
    const response = await axiosInstance.get(`staff/products/v1?searchKey=${request.searchKey}&sizeOfPage=50`);
    return response.data;
};

export const clonePackageApi = async (request) => {
    const response = await axiosInstance.post(`staff/packages/${request.id}/clone`, request.formData);
    return response.data;
};

export const deletePackageApi = async (request) => {
    const response = await axiosInstance.delete(`staff/packages/${request.id}`);
    return response.data;
};

export const updatePackageStatusApi = async (request) => {
    const response = await axiosInstance.put(`staff/packages/${request.id}/status?active=${request.active}`);
    return response.data;
};

export const deletePackageProductApi = async (request) => {
    const response = await axiosInstance.delete(`staff/package/product/${request.id}`);
    return response.data;
};
